import { useQuery } from "@tanstack/react-query";
import { GetApplicationsRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

const useGetApplications = (tempWorkerId: number, props?: Props) => {
    const {data, isLoading, isError} = useQuery<any>(['temp_workers', `${tempWorkerId}`, 'applications'], () => GetApplicationsRequest(tempWorkerId), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

export { useGetApplications };
